import { isValidPhoneInput } from "@rentiohq/shared-frontend/dist/utils/phone/phone.utils";

const DEFAULT_EXCLUDED_KEYS = ["password"];

export const removeLeadingAndTrailingSpaces = (input: string) => {
  if (!input) return;
  return input.trim().replace(/^[\r|\n|\r\n]$/, "");
};

export const trimAllValuesInObject = (
  values: Record<string, string>,
  excludedKeys?: string[],
) => {
  const _excludedKeys = [...DEFAULT_EXCLUDED_KEYS, ...(excludedKeys || [])];
  return Object.entries(values).reduce(
    (finalObject, [key, value]: [string, unknown]) => ({
      ...finalObject,
      [key]:
        _excludedKeys.includes(key) || typeof value !== "string"
          ? value
          : removeLeadingAndTrailingSpaces(value as string),
    }),
    {},
  );
};

// The pro profile is a legacy `JsonForm`, which compiles its schema's
// `validPhone` keyword but never runs it, so its submit checks the phone with
// this. `formData` holds the phone the form was opened with (SM-470). The
// submit sends the phone only when it differs from that value, so an unchanged
// phone is not checked at all.
export const isProfilePhoneValid = (
  values: { phone?: string },
  formData: { phone?: string },
) =>
  values.phone === formData.phone ||
  isValidPhoneInput({ phone: values.phone, storedPhone: formData.phone });
